import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-subtitle-1 font-weight-bold" }
const _hoisted_2 = { class: "text-subtitle-2 text-gray" }

import HomeViewModel from "@/viewmodels/app/HomeViewModel";


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeComponent',
  setup(__props) {

const viewModel = new HomeViewModel();

return (_ctx: any,_cache: any) => {
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_spacer = _resolveComponent("v-spacer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              flat: "",
              border: "",
              class: "pa-4 text-start rounded-sm",
              height: "120"
            }, {
              default: _withCtx(() => [
                _createElementVNode("strong", _hoisted_1, _toDisplayString(_unref(viewModel).hideWords(_unref(viewModel).userName.value)), 1),
                _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(viewModel).hideEmailCharacters(_unref(viewModel).userEmail.value)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              flat: "",
              border: "",
              class: "pa-4 text-start rounded-sm overflow-y-auto",
              height: "120"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item, { class: "rounded" }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_v_avatar, {
                      size: "70",
                      rounded: "lg",
                      color: "secondary",
                      class: "text-white"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[1] || (_cache[1] = [
                            _createTextVNode("mdi-account-tie")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, { class: "text-subtitle-1 font-weight-bold" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(viewModel).userHasAssessor.value
                  ? `Tu Asesor: ${_unref(viewModel).assessorName.value}`
                  : "No tienes asesor asignado"), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_list_item_subtitle, { class: "text-subtitle-2" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(viewModel).userHasAssessor.value
                  ? `Contacto: ${
                      _unref(viewModel).assessorPhone.value || "No disponible"
                    }`
                  : "Por favor contacta a la cooperativa para más información"), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  append: _withCtx(() => [
                    (
                _unref(viewModel).userHasAssessor.value && _unref(viewModel).assessorPhone.value
              )
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          color: "secondary",
                          variant: "text",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(viewModel).callAssessor(_unref(viewModel).assessorPhone.value)))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { left: "" }, {
                              default: _withCtx(() => _cache[2] || (_cache[2] = [
                                _createTextVNode("mdi-phone")
                              ])),
                              _: 1
                            }),
                            _cache[3] || (_cache[3] = _createTextVNode(" Llamar "))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              flat: "",
              border: "",
              class: "pa-4 text-start"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "text-subtitle-1 font-weight-bold px-0" }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("Tus Aportes")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card, {
              flat: "",
              border: "",
              class: "pa-4 text-start rounded-sm overflow-y-auto",
              height: "200"
            }, {
              default: _withCtx(() => [
                (_unref(viewModel).loading.value)
                  ? (_openBlock(), _createBlock(_component_v_card_subtitle, { key: 0 }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(1, (n) => {
                          return _createVNode(_component_v_skeleton_loader, {
                            class: "mx-4 my-2",
                            type: "list-item-two-line",
                            key: 'skeleton-contribution-' + n
                          })
                        }), 64))
                      ]),
                      _: 1
                    }))
                  : (_unref(viewModel).contributions.value.length > 0)
                    ? (_openBlock(), _createBlock(_component_v_list, { key: 1 }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(viewModel).contributions.value, (contribution, index) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 'contribution-' + index,
                              onClick: ($event: any) => (_unref(viewModel).goToContributions(contribution)),
                              class: "pa-4 mb-2 cursor-pointer",
                              border: "",
                              style: {"border-left":"7px solid rgb(var(--v-theme-primary), 0.4)"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, { class: "text-subtitle-1 font-weight-bold" }, {
                                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                                    _createTextVNode("Total")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_v_list_item_subtitle, { class: "text-subtitle-1 py-2" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(viewModel).formatCoin(contribution.moneda)) + " " + _toDisplayString(_unref(viewModel).formatFloat(contribution.saldoaporte)), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => _cache[6] || (_cache[6] = [
                                    _createTextVNode("mdi-chevron-right")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_alert, {
                        key: 2,
                        type: "info",
                        class: "text-center text-subtitle-2",
                        variant: "tonal",
                        text: "Aún no ha realizado ningún aporte.",
                        border: ""
                      }))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              flat: "",
              border: "",
              class: "pa-4 text-start"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "text-subtitle-1 font-weight-bold px-0" }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("Tus Créditos")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card, {
              class: "pa-4 text-start rounded-sm overflow-y-auto",
              height: "200",
              border: "",
              flat: ""
            }, {
              default: _withCtx(() => [
                (_unref(viewModel).loading.value)
                  ? (_openBlock(), _createBlock(_component_v_card_subtitle, { key: 0 }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(1, (n) => {
                          return _createVNode(_component_v_skeleton_loader, {
                            class: "mx-4 my-2",
                            type: "list-item-two-line",
                            key: 'skeleton-credit-' + n
                          })
                        }), 64))
                      ]),
                      _: 1
                    }))
                  : (_unref(viewModel).credits.value.length > 0)
                    ? (_openBlock(), _createBlock(_component_v_list, { key: 1 }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(viewModel).credits.value, (credit, index) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 'credit-' + index,
                              onClick: ($event: any) => (_unref(viewModel).goToCreditDetail(credit)),
                              class: "pa-4 mb-2 cursor-pointer",
                              border: "",
                              style: {"border-left":"7px solid rgb(var(--v-theme-primary), 0.4)"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, { class: "text-subtitle-1 font-weight-bold" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(credit.nom), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_list_item_subtitle, { class: "text-subtitle-1 py-1 d-flex justify-space-between" }, {
                                  default: _withCtx(() => [
                                    _cache[8] || (_cache[8] = _createElementVNode("span", null, " Créd. desembolsado: ", -1)),
                                    _createElementVNode("strong", null, _toDisplayString(_unref(viewModel).formatCoin(credit.moneda)) + " " + _toDisplayString(_unref(viewModel).formatFloat(credit.montodesembolsado)), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_progress_linear, {
                                  "model-value": 
                  _unref(viewModel).percentDisbursement(
                    credit.montodesembolsado,
                    credit.saldo
                  )
                ,
                                  color: "amber",
                                  class: "mt-2 rounded-lg",
                                  height: "9"
                                }, null, 8, ["model-value"])
                              ]),
                              append: _withCtx(() => [
                                _createVNode(_component_v_icon, null, {
                                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                                    _createTextVNode("mdi-chevron-right")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_alert, {
                        key: 2,
                        type: "info",
                        class: "text-center text-subtitle-2",
                        variant: "tonal",
                        text: "Actualmente no tienes créditos pendientes.",
                        border: ""
                      }))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "12",
          md: "4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              flat: "",
              border: "",
              class: "pa-4 text-start"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "text-subtitle-1 font-weight-bold px-0" }, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                    _createTextVNode("Tus Ahorros")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card, {
              class: "pa-4 text-start rounded-sm overflow-y-auto",
              height: "200",
              border: "",
              flat: ""
            }, {
              default: _withCtx(() => [
                (_unref(viewModel).loading.value)
                  ? (_openBlock(), _createBlock(_component_v_card_subtitle, { key: 0 }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(1, (n) => {
                          return _createVNode(_component_v_skeleton_loader, {
                            class: "mx-4 my-2",
                            type: "list-item-two-line",
                            key: 'skeleton-saver-' + n
                          })
                        }), 64))
                      ]),
                      _: 1
                    }))
                  : (_unref(viewModel).savers.value.length > 0)
                    ? (_openBlock(), _createBlock(_component_v_list, { key: 1 }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(viewModel).savers.value, (saver, index) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 'saver-' + index,
                              class: "pa-4 mb-2 cursor-pointer",
                              border: "",
                              style: {"border-left":"7px solid rgb(var(--v-theme-primary), 0.4)"},
                              onClick: _withModifiers(($event: any) => (_unref(viewModel).goToSaving(saver)), ["prevent"])
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, { class: "text-subtitle-1 font-weight-bold" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(viewModel).capitalize(saver.TIPO_AHORRO)), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_list_item_subtitle, { class: "text-subtitle-1 py-1 d-flex justify-space-between" }, {
                                  default: _withCtx(() => [
                                    _cache[11] || (_cache[11] = _createElementVNode("span", null, " Saldo disponible: ", -1)),
                                    _createVNode(_component_v_spacer),
                                    _createElementVNode("span", null, _toDisplayString(_unref(viewModel).formatCoin(saver.moneda)) + " " + _toDisplayString(_unref(viewModel).formatFloat(saver.saldo)), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_alert, {
                        key: 2,
                        type: "info",
                        class: "text-center text-subtitle-2",
                        variant: "tonal",
                        text: "Actualmente no tienes ahorros aperturados.",
                        border: ""
                      }))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "12" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              flat: "",
              border: "",
              class: "pa-4 text-start rounded-sm overflow-y-auto",
              height: "540"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "text-subtitle-1 font-weight-bold" }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createTextVNode(" Últimos Movimientos ")
                  ])),
                  _: 1
                }),
                (_unref(viewModel).loading.value)
                  ? (_openBlock(), _createBlock(_component_v_card_subtitle, { key: 0 }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
                          return _createVNode(_component_v_skeleton_loader, {
                            class: "mx-4 my-2",
                            type: "list-item-two-line",
                            key: 'skeleton-movement-' + n
                          })
                        }), 64))
                      ]),
                      _: 1
                    }))
                  : (_unref(viewModel).transactions.value.length > 0)
                    ? (_openBlock(), _createBlock(_component_v_list, {
                        key: 1,
                        class: "bg-transparent"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(viewModel).transactions.value, (movement, index) => {
                            return (_openBlock(), _createBlock(_component_v_list_item, {
                              key: 'movement-' + index,
                              class: "pa-4 mb-2 border-b-sm",
                              style: {"border-left":"7px solid rgb(var(--v-theme-primary), 0.4)"}
                            }, {
                              prepend: _withCtx(() => [
                                _createVNode(_component_v_avatar, {
                                  rounded: "lg",
                                  size: "48",
                                  variant: "tonal",
                                  color: _unref(viewModel).getColor(movement.tipomov)
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { size: "20" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(viewModel).getIconName(movement.tipomov)), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["color"])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, { class: "text-subtitle-1 font-weight-bold" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(movement.concepto), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_list_item_subtitle, { class: "text-subtitle-2 py-1" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(movement.fecha) + " - " + _toDisplayString(movement.hora), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              append: _withCtx(() => [
                                _createVNode(_component_v_list_item_subtitle, {
                                  class: _normalizeClass(["text-subtitle-1 font-weight-bold", `text-${_unref(viewModel).getColor(movement.tipomov)}`])
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("strong", null, _toDisplayString(_unref(viewModel).formatCoin(movement.moneda)) + " " + _toDisplayString(_unref(viewModel).formatFloat(movement.saldoaporte)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["class"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_v_alert, {
                        key: 2,
                        type: "info",
                        class: "text-center text-subtitle-2",
                        variant: "tonal",
                        text: "Actualmente no tienes movimientos recientes.",
                        border: ""
                      }))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})